/**
 * Early script to detect page load state.
 */

// Fires just before DOMContentLoaded.
document.onreadystatechange = () => {
	// As soon as document is interactive, remove the no-js class.
	if ( document.readyState === 'interactive' ) {
		document.body.classList.remove( 'no-js' );
	}
};

function handlePageLoad() {
	// Remove the loading class from the body.
	document.body.classList.remove( 'loading' );
	document.body.classList.add( 'loaded' );
}

window.addEventListener( 'load', () => {
	// Remove the loading class from the body.
	handlePageLoad();
} );

// Check if the page has already loaded.
if ( document.readyState === 'complete' ) {
	// Remove the loading class from the body.
	handlePageLoad();
}
